<template>
    <ui-PanelThermostat
        v-if="device"
        :show="show"
        :name="deviceNotNull.name"
        :ubication="location.name || $dicc.locations.default"
        :typeSpace="space.type"
        :temperaturaLabel="$dicc.devicePanel.temperature"
        :temperaturaValue="status.getTemp() | toNumber"
        :consignaShow="status.isOn()"
        :consignaLabel="$dicc.devicePanel.consigna"
        :consignaValue="status.getOrder() | toNumber"
        :humedadLabel="$dicc.devicePanel.humidity"
        :humedadValue="status.getHumidity() | toNumber"
        :programming="showPrograms"
        :modeLabel="modeLabel()"
        :modeIcoTarget="modeIcoTarget()"
        :modeHeat="status.isModeHeat()"
        :outService="status.isOutService()"
    >
        <template v-slot:menuBar>
            <PanelMixinBack></PanelMixinBack>
            <RefreshIco></RefreshIco>
            <div
                class="icoButton"
                :class="{ 'icoButton--active': deviceNotNull.is_favourite }"
                data-icoTarget="favorites"
                @click="toggleFavourite()"
            ></div>
            <div class="icoButton" data-icoTarget="setUp" @click="$emit('openSettings', { device, location })"></div>
        </template>

        <template v-slot:body>
            <ui-TempControlDevice
                :vertical="true"
                :min="status.getTempMin() | toNumber"
                :max="status.getTempMax() | toNumber"
                :real="status.getTemp() | toNumber"
                :order="status.getOrder() | toNumber"
                :status="status.isOn()"
                :standby="status.isStanby()"
                :modeHeat="status.isModeHeat()"
                @update:order="updateOrder($event)"
            ></ui-TempControlDevice>
            <div class="blocks" :class="{ modeHeat: status.isModeHeat() }">
                <div class="block">
                    <ui-Switch
                        :status="status.isOn()"
                        :standby="status.isStanby()"
                        :disabled="deviceNotNull.disabled"
                        @update:status="togglePowerDevice"
                    ></ui-Switch>
                    <p class="titleSection">{{ $dicc.devicePanel.activeSystems }}</p>
                    <ui-IcoBtn
                        :sizeLg="true"
                        :active="status.isModeAC()"
                        :label="$dicc.devicePanel.ac"
                        valueIco="ac"
                        @click="toggleAC(!status.isModeAC())"
                    ></ui-IcoBtn>
                    &nbsp;
                    <ui-IcoBtn
                        v-if="status.allowFloor()"
                        :sizeLg="true"
                        :active="status.isModeFloor()"
                        :label="$dicc.devicePanel.floor"
                        valueIco="radiatingFloor"
                        @click="toggleRadiatingFloor(!status.isModeFloor())"
                    ></ui-IcoBtn>
                    <ui-IcoGroup
                        v-if="status.allowFan()"
                        valueIco="ventilation"
                        name="Ventilador"
                        :actives="status.hasFanMode() ? [status.getFanMode()] : []"
                        :groups="fanGroups"
                        @click="updateFanMode(status.hasFanMode() ? '0' : '4')"
                        @itemClick="updateFanMode($event.value)"
                    ></ui-IcoGroup>
                </div>
                <div class="block" v-if="status.allowTimer() || status.allowPrograms()">
                    <p class="titleSection">{{ $dicc.devicePanel.programs }}</p>
                    <ui-IcoGroup
                        v-if="status.allowTimer()"
                        valueIco="timer"
                        name="3' para apagado"
                        :actives="status.hasTimer() ? [status.getTimer()] : []"
                        :groups="timerGroups"
                        @click="updateTimer(status.hasTimer() ? '0' : '30')"
                        @itemClick="updateTimer($event.value)"
                    >
                    </ui-IcoGroup>
                    <ui-IcoGroup
                        v-if="status.allowPrograms()"
                        valueIco="clock"
                        __name="Programaciones"
                        :groupInfo="
                            hasAnyProgramActive() ? $dicc.devicePanel.programsAuto : $dicc.devicePanel.programsManual
                        "
                        :active="hasAnyProgramEnable()"
                        :activeInfo="hasAnyProgramActive()"
                        :actives="[]"
                        :groups="[]"
                        @click="showSlotPrograms()"
                        @itemClick="fanMode = $event"
                    >
                    </ui-IcoGroup>
                </div>
            </div>
        </template>

        <template v-slot:bodyProgramming v-if="status.allowPrograms()">
            <Program
                :status="status"
                v-for="program in programs"
                :key="program.reference"
                :program="program"
                :installationRef="installation_ref"
                :deviceRef="reference"
                @update="init(null, $event)"
            ></Program>
            <a class="btn btn--simple mt-3 programming__close" @click="showPrograms = false">{{ $dicc.devicePanel.closePrograms }}</a>
        </template>
    </ui-PanelThermostat>
</template>

<script>
    import ProgramClass from '../models/Program';
    import Program from '../components/Program';
    import { DeviceMixin } from '../mixins/DeviceMixin';
    import { PanelMixin } from '../mixins/PanelMixin';
    import RefreshIco from '../components/RefreshIco';

    export default {
        name: 'DevicePanel',
        mixins: [DeviceMixin, PanelMixin],
        components: { Program, RefreshIco },
        data() {
            return {
                type: 'device',
                //fanMode: null,
                fanGroups: [
                    { key: 'auto', values: { 4: 'A' } },
                    { key: 'manual', values: { 1: '1', 2: '2', 3: '3' } },
                ],
                timerGroups: [{ key: 'minutes', values: ['30', '60', '90', '120'] }],
                showPrograms: false,
                //device: null,
            };
        },
        mounted() {
            this.$onInstance('refresh', () => {
                this.init(
                    () => this.$emitInstance('startRefresh'),
                    () => this.$emitInstance('endRefresh')
                );
            });
            this.init();
        },
        methods: {
            init(callbackStart, callbackEND) {
                if (!this.device || !this.show) return;

                if (this.status.allowPrograms()) {
                    if (callbackStart) callbackStart();
                    this.getPrograms(
                        this.installation_ref,
                        this.reference,
                        (message) => {
                            this.programs = JSON.parse(message.value.slice(1, -2)).map(
                                (program) => new ProgramClass(program, this.status)
                            );
                        },
                        (data) => {
                            dd(data);
                        },
                        callbackEND
                    );
                }
            },

            modeLabel() {
                return this.status.isModeHeat() ? this.$dicc.hot : this.$dicc.cool;
            },

            modeIcoTarget() {
                return this.status.isModeHeat() ? 'mode-heat' : 'mode-cool';
            },

            toggleFavourite() {
                if (this.device.is_favourite) this.deleteFavourite();
                else this.addFavourite();
            },

            addFavourite() {
                this.device.is_favourite = true;
                this.$api.addFavourite(this.device, null, (error) => {
                    this.device.is_favourite = false;
                    this.$toast({
                        message: error,
                        type: 'is-danger',
                    });
                });
            },

            deleteFavourite() {
                this.device.is_favourite = false;
                this.$api.deleteFavourite(this.device, null, (error) => {
                    this.device.is_favourite = true;
                    this.$toast({
                        message: error,
                        type: 'is-danger',
                    });
                });
                return;
            },

            showSlotPrograms() {
                this.showPrograms = true;
                if (this.showPrograms && this.programs.length == 0) this.init();
            },

            hasAnyProgramEnable() {
                return this.programs.some((program) => program.isEnable());
            },

            hasAnyProgramActive() {
                return this.programs.some((program) => program.isActive());
            },

            // refresh() {
            //     this.init();
            //     this.getStatus(this.installation_ref);
            // },
        },
        computed: {
            deviceNotNull() {
                return this.device ? this.device : {};
            },
        },
        watch: {
            device: {
                immediate: true,
                handler() {
                    this.showPrograms = false;
                    this.init();
                },
            },
        },
    };
</script>
